<template>
  <div>
    <h5>Vehicle Make</h5>
    <select @change="setMakes()" v-model="filtermodel.make">
      <option :value="null">All Makes</option>
      <option v-for="(make,key) in makesList" :key="key" :value="make">{{make}}</option>
    </select>
    <h5>Vehicle Model</h5>
    <select @change="setModel()" v-model="filtermodel.model" :disabled="modelsList.length==0?true:false">
      <option :value="null">All Models</option>
      <option v-for="(model,key) in modelsList" :key="key" :value="model">{{model}}</option>
    </select>
    <h5>Vehicle Trim</h5>
    <select @change="updateFilterModel()" v-model="filtermodel.trim" :disabled="trimsList.length==0 ? true: false">
      <option :value="null">All Trims</option>
      <option v-for="(trim,key) in trimsList" :key="key" :value="trim">{{trim}}</option>
    </select>
    <div>
      <div class="select-left">
        <h5>Vehicle Year: from</h5>
        <select @change="updateFilterModel()" v-model="filtermodel.yearFrom">
          <option :value="null">All Year</option>
          <option v-for="(year,key) in yearList" :key="key" :value="year"
            :disabled='year >= filtermodel.yearTo &&  filtermodel.yearTo != null '>{{year}}</option>
        </select>
      </div>
      <div class="select-right">
        <h5>Vehicle Year: to</h5>
        <select @change="updateFilterModel()" v-model="filtermodel.yearTo">
          <option :value="null">All Year</option>
          <option v-for="(year,key) in yearList" :key="key" :value="year"
            :disabled='filtermodel.yearFrom >= year &&  filtermodel.yearFrom != null '>{{year}}</option>
        </select>
      </div>
    </div>
    <div style="clear:both"></div>
    <div>
      <div class="select-left">
        <h5>Vehicle Price: min</h5>
        <select @change="updateFilterModel()" v-model="filtermodel.priceFrom">
          <option :value="null">$0</option>
          <option v-for="(opt, i) in priceOptions" :key="i" :disabled="filtermodel.priceTo != null && (opt.value >= filtermodel.priceTo)" :value="opt.value" >{{opt.text}}</option>
        </select>
      </div>
      <div class="select-right">
        <h5>Vehicle Price: max</h5>
        <select @change="updateFilterModel()" v-model="filtermodel.priceTo">
          <option :value="null">Max price</option>
          <option v-for="(opt, i) in priceOptions" :key="i" :disabled="filtermodel.priceFrom != null && (opt.value <= filtermodel.priceFrom)" :value="opt.value" >{{opt.text}}</option>
        </select>
      </div>
    </div>
    <div style="clear:both"></div>
    <h5>Vehicle Body</h5>
    <select @change="updateFilterModel()" v-model="filtermodel.bodyType">
      <option :value="null">All Bodies</option>
      <option v-for="(bodyType,key) in bodysList" :key="key" :value="bodyType">{{bodyType}}</option>
    </select>
    <div class='buttons'>
      <div v-show="!isLoaded" class="loader">
        <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
      </div>
      <div v-show="isLoaded" class='select-left'>
        <button @click="resetFilterModel">
          <img src='../../assets/icons/black/menu_close.png'> <span>RESET SEARCH</span>
        </button>
      </div>
      <div v-show="isLoaded" class='select-right'>
        <input type="button" @click='search' style="font-size:13.3px; font-weight:bold" value="Show Result"
          :style="borderStyle" class="button form_submit" />
      </div>
    </div>
  </div>
</template>
<script>
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import dealertrendFilterCore from '@/mixins/dealertrend.filter.mixin.js'
  export default {
    name: 'dealertrend-filter',
    props: {
      loading: {
        type: Boolean
      }
    },
    components: {
      LoopingRhombusesSpinner
    },
    mixins: [dealertrendFilterCore],
    watch: {
      loading (val) { this.isLoaded = !val }
    },
    methods: {
      async search () {
        this.filtermodel.page = 1
        await this.updateFilter(this.filtermodel)
        this.$emit('searchClick', null)
      }
    }
  }
</script>
<style scoped>
  .button_full {
    margin-top: 20px
  }

  select {
    width: 100%;
    height: 35px;
    font-size: 18px;
    padding-left: 5px;
  }

  h5 {
    font-weight: bold;
    padding: 10px 0 10px 0;
  }

  .select-left {
    width: 45%;
    float: left;
    display: block;
  }

  .select-right {
    width: 45%;
    float: right;
    display: block;
  }

  button {
    text-align: center;
    position: relative;
    background-color: #fff;
    border: none;
    margin-top: 20px;
  }

  button img {
    width: 20px;
    position: absolute;
    top: -2px;
  }

  button span {
    margin-left: 25px;
    font-weight: bold;
  }

  .buttons {
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// dealertrend-filter.vue?69ce15a8